import React, { useState } from 'react';
import axios from 'axios';
import '../components/css/CreateAdminPopup.css'; // or rename to CreateUserPopup.css

const API_BASE = '';

const Register = ({ onClose }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    password: '',
    termsAccepted: false,
    logoFile: null,
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.termsAccepted) {
      setError('You must accept the terms to continue.');
      return;
    }

    try {
      const form = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) form.append(key, formData[key]);
      });

      await axios.post(`${API_BASE}/api/admin/register-initial`, form);

      setSuccess('✅ Registered successfully!');
      setError('');
      setTimeout(() => {
        onClose && onClose();
      }, 1500);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Registration failed.');
      setSuccess('');
    }
  };

  return (
    <div className="create-admin-popup">
      <div className="popup-overlay" onClick={onClose}></div>
      <div className="popup-content">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Create Account</h2>
        <form onSubmit={handleSubmit}>
          <input name="firstName" placeholder="First Name" onChange={handleChange} required />
          <input name="lastName" placeholder="Last Name" onChange={handleChange} required />
          <input name="mobileNumber" placeholder="Mobile Number" onChange={handleChange} required />
          <input name="email" type="email" placeholder="Email" onChange={handleChange} required />
          <input name="password" type="password" placeholder="Password" onChange={handleChange} required />
          <input name="logoFile" type="file" accept="image/*" onChange={handleChange} />
          <label>
            <input type="checkbox" name="termsAccepted" onChange={handleChange} />
            I accept the terms & conditions
          </label>
          <button type="submit">Register</button>
        </form>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'lime' }}>{success}</p>}
      </div>
    </div>
  );
};

export default Register;

